<template>
  <div>
    <salesforce-shop-requests v-if="isAllowedToAccess"></salesforce-shop-requests>
    <number-management />
    <internet-post />
    <phoneshop-post />
    <group-shop />
    <InternetShopCustomForm v-if="isAllowedToAccess"></InternetShopCustomForm>
  </div>
</template>
<script>
import NumberManagement from '../components/secretshop/NumberManagement.vue';
import InternetPost from '../components/secretshop/InternetPost.vue';
import PhoneshopPost from '../components/secretshop/PhoneshopPost.vue';
import GroupShop from '../components/secretshop/GroupShop.vue';
import SalesforceShopRequests from '../components/salesforce/SalesforceShopRequests.vue';
import InternetShopCustomForm from './InternetShopCustomForm.vue';
import { some as _some } from 'lodash-es';


export default {
  name: 'SecretshopManagement',
  components: {
    NumberManagement,
    InternetPost,
    PhoneshopPost,
    GroupShop,
    SalesforceShopRequests,
    InternetShopCustomForm,
  },
  created() {
    this.getStates();
    this.$store.dispatch('dealers/getDealers');
    this.getStatuses();
  },
  computed: {
    isAllowedToAccess() {
      if (
        window.location.origin.toString().includes('127.0.0.1')
      ) {
        return true;
      }

      return (
        _some(
          this.$auth.user().roles,
          {
            name: 'super-administrator',
          } && window.location.origin.toString().includes('app.webinarinc')
        ) ||
        _some(this.$auth.user().roles, {
          name: 'secret-shopper',
        }) ||
        this.$auth.user().dealer.name === 'TrueCar' ||
        this.$auth.user().dealer_id === 48
      );
    },
  },
  methods: {
    getStatuses() {
      this.axios.get('secret-shop-statuses').then(({ data }) => {
        this.$store.dispatch('secretShopStatuses/setStatuses', data.statuses);
      });
    },
    getStates() {
      this.$http.get('/states').then(({ data }) => {
        this.$store.dispatch('states/setStates', data);
      });
    },
  },
};
</script>
